<!-- Main Container -->
<div class="card">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      Events
    </h3>
  </div>
  <div class="p-4">
    <kendo-grid [kendoGridBinding]="events" [pageSize]="20" [pageable]="true" [sortable]="true"
      (edit)="editHandler($event)" (add)="addHandler($event)" (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)">
      <ng-template kendoGridToolbarTemplate>
        <button type="button" icon="plus-outline" look="flat" kendoGridAddCommand>
          Add New Record
        </button>
        <button type="button" icon="refresh-sm" look="flat" kendoButton class="display-end">
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column field="eventDescription" title="Event Description" width="200">
        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup" let-isNew="isNew">
          <input class="k-textbox k-adjust-width" [formControl]="formGroup.get(column.field)" maxlength="250"
            kendoTextBox />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="active" title="Active" width="50">
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.active" disabled />
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-column="column" let-formGroup="formGroup">
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Command" width="100">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
          <button kendoGridEditCommand [primary]="true">Edit</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            Save
          </button>
          <button kendoGridCancelCommand>Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>